/*
 * menu-trigger btn
 * ----------------------------------------------- */
jQuery(function ($) {
  var $btnHamburger = $(".btn-hamburger");
  var $mainMenu = $(".main-menu");

  $btnHamburger.click(function () {
    $(this).toggleClass("active");
    if ($mainMenu.hasClass("wave-off")) {
      setTimeout(() => {
        $mainMenu.addClass("active");
      }, 150);
      $mainMenu.removeClass("wave-off").addClass("wave-on");
    } else {
      $mainMenu.removeClass("wave-on").addClass("wave-off");
      setTimeout(() => {
        $mainMenu.removeClass("active");
      }, 150);
    }

    return false;
  });
});
